var EMPTY_BUNDLE = {
  EMPTY_TITLE: 'empty_bundle_error_title',
  EMPTY_SUB_TITLE: 'empty_bundle_error_desc'
};
var commonMobileBreakpoints = {
  768: 3.8,
  480: 2.5,
  414: 2.1,
  411: 2.1,
  375: 1.9,
  360: 1.8
};
var mobileBreakPoints = Object.assign({
  1650: 8.4
}, commonMobileBreakpoints);
var mobileBreakPointsBuyengager = Object.assign({
  1650: 3.8
}, commonMobileBreakpoints);
var mobileBreakPointsWithTag = Object.assign(Object.assign({}, mobileBreakPoints), {
  375: 2.2,
  360: 2.2
});
export { EMPTY_BUNDLE, mobileBreakPoints, mobileBreakPointsWithTag, mobileBreakPointsBuyengager };